// we need our modal component
import AppModalAsync from './../components/alerts/AppModalAsync.vue'

const MyAppModalAsync = {
  // every plugin for Vue.js needs install method
  // this method will run after Vue.use(<your-plugin-here>) is executed
  install(Vue, options) {
    // We must create new Eventbus
    // which is just another Vue instance that will be listening for and emiting events from our main instance
    // this EventBus will be available as Modal.EventBus
    this.EventBus = new Vue()

    // making our modal component global
    Vue.component('app-modal-async', AppModalAsync)

    // exposing global $modal object with method show()
    // method show() takes object params as argument
    // inside this object we can have modal title, text, styles... and also our callback confirm function
    Vue.prototype.$appModalAsync = {
      show(params) {
        MyAppModalAsync.EventBus.$emit('show', params)
      },
      start(params) {
        MyAppModalAsync.EventBus.$emit('start', params)
      },
      end() {
        MyAppModalAsync.EventBus.$emit('end')
      }
    }
  }
}

export default MyAppModalAsync


// WEBPACK FOOTER //
// ./src/plugins/AppModalAsync.js